/**
 * @generated SignedSource<<f1847468f9c113fd1a1724bdb8e1905a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TicketChannel = "manual" | "email" | "phone" | "chat" | "internal" | "api" | "customer_portal" | "direct" | "%future added value";
export type TicketLinkType = "related" | "child" | "project" | "forecast_task" | "%future added value";
export type TicketPriority = "p0" | "p1" | "p2" | "p3" | "%future added value";
export type TicketStatus = "open" | "in_progress" | "waiting_on_customer" | "resolved" | "closed" | "%future added value";
export type useTicketDetailBySlugQuery$variables = {
  slug: string;
};
export type useTicketDetailBySlugQuery$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly ticketDetailBySlug: {
      readonly ticket: {
        readonly id: string;
        readonly slug: string;
        readonly subject: string;
        readonly description: string | null;
        readonly status: TicketStatus;
        readonly priority: TicketPriority;
        readonly channel: TicketChannel;
        readonly assigneeId: string | null;
        readonly assignee: {
          readonly fullName: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"ticketingPerson_person">;
        } | null;
        readonly requester: {
          readonly id: string;
          readonly name: string;
          readonly email: string;
        } | null;
        readonly createdAt: string;
        readonly updatedAt: string;
        readonly closedAt: string | null;
        readonly links: ReadonlyArray<{
          readonly __typename: string;
          readonly linkType: TicketLinkType;
          readonly targetTicket: {
            readonly id: string;
          } | null;
          readonly targetProject: {
            readonly id: string;
          } | null;
        }>;
        readonly timeEntries: ReadonlyArray<{
          readonly id: string;
        }>;
        readonly linkedTasks: ReadonlyArray<{
          readonly id: string;
        }>;
        readonly ticketTimeRegistrations: ReadonlyArray<{
          readonly id: string;
        }>;
        readonly " $fragmentSpreads": FragmentRefs<"TicketDetailHeader_ticket" | "TicketMetaPanel_ticket" | "RelatedTab_ticket" | "LinkedTasksTab_ticket" | "TimeTab_ticket" | "WatchersList_ticket" | "AiSummaryBlock_ticket" | "AiSuggestedActionsList_ticket">;
      };
      readonly timeline: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"ActivityTimelineItem_activity" | "ActivityTab_activity" | "StreamTab_activity">;
      }>;
      readonly attachments: ReadonlyArray<{
        readonly id: string;
        readonly filename: string;
        readonly contentType: string;
        readonly sizeBytes: number;
        readonly downloadUrl: string;
        readonly uploadedBy: {
          readonly id: string;
          readonly fullName: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"ticketingPerson_person">;
        } | null;
        readonly uploadedByName: string | null;
        readonly createdAt: string;
      }>;
    } | null;
  } | null;
};
export type useTicketDetailBySlugQuery = {
  variables: useTicketDetailBySlugQuery$variables;
  response: useTicketDetailBySlugQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subject",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channel",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assigneeId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v12 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ticketingPerson_person"
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Requester",
  "kind": "LinkedField",
  "name": "requester",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closedAt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkType",
  "storageKey": null
},
v20 = [
  (v3/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeEntry",
  "kind": "LinkedField",
  "name": "timeEntries",
  "plural": true,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filename",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentType",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sizeBytes",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "downloadUrl",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadedByName",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initials",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v34 = [
  (v13/*: any*/),
  (v3/*: any*/)
],
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v36 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "readOnly",
    "storageKey": null
  }
],
v37 = [
  (v3/*: any*/),
  (v11/*: any*/)
],
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    (v11/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/),
    (v31/*: any*/)
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": (v37/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTicketDetailBySlugQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TicketDetail",
            "kind": "LinkedField",
            "name": "ticketDetailBySlug",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Ticket",
                "kind": "LinkedField",
                "name": "ticket",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "assignee",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TicketLink",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TicketLinkTarget",
                        "kind": "LinkedField",
                        "name": "targetTicket",
                        "plural": false,
                        "selections": (v20/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectLinkTarget",
                        "kind": "LinkedField",
                        "name": "targetProject",
                        "plural": false,
                        "selections": (v20/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TicketDetailHeader_ticket"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TicketMetaPanel_ticket"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RelatedTab_ticket"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "LinkedTasksTab_ticket"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TimeTab_ticket"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "WatchersList_ticket"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AiSummaryBlock_ticket"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AiSuggestedActionsList_ticket"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "linkedTasks",
                    "plural": true,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeRegType",
                    "kind": "LinkedField",
                    "name": "ticketTimeRegistrations",
                    "plural": true,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "timeline",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ActivityTimelineItem_activity"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ActivityTab_activity"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "StreamTab_activity"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TicketAttachment",
                "kind": "LinkedField",
                "name": "attachments",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "uploadedBy",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTicketDetailBySlugQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TicketDetail",
            "kind": "LinkedField",
            "name": "ticketDetailBySlug",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Ticket",
                "kind": "LinkedField",
                "name": "ticket",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "assignee",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v3/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TicketLink",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TicketLinkTarget",
                        "kind": "LinkedField",
                        "name": "targetTicket",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v32/*: any*/),
                          (v5/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "assignee",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v31/*: any*/),
                              (v3/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v30/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectLinkTarget",
                        "kind": "LinkedField",
                        "name": "targetProject",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v13/*: any*/),
                          (v33/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isWatching",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "watcherCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalLoggedHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalBillableHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TicketSla",
                    "kind": "LinkedField",
                    "name": "sla",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "breached",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "elapsedSeconds",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "thresholdSeconds",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "paused",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v13/*: any*/),
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LabelCategory",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": (v34/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TicketLinkTarget",
                    "kind": "LinkedField",
                    "name": "parentTicket",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v32/*: any*/),
                      (v5/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomFieldValueV2TypeConnection",
                    "kind": "LinkedField",
                    "name": "customFields",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomFieldValueV2TypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "key",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "type",
                                "storageKey": null
                              },
                              (v35/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "value",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayValue",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v36/*: any*/),
                                "type": "TextCustomFieldValue",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v36/*: any*/),
                                "type": "IntegerCustomFieldValue",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v36/*: any*/),
                                "type": "DecimalCustomFieldValue",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v36/*: any*/),
                                "type": "DateCustomFieldValue",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CustomFieldDropdownOption",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v35/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "DropdownCustomFieldValue",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aiSuggestedLinkedTaskIds",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalLinkedTaskMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "linkedTasks",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "companyTaskId",
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalMinutesRegistered",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "estimateForecastMinutes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deadlineYear",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deadlineMonth",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deadlineDay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StatusColumnV2",
                        "kind": "LinkedField",
                        "name": "statusColumnV2",
                        "plural": false,
                        "selections": (v34/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "assignedPersons",
                        "plural": true,
                        "selections": (v37/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeRegType",
                    "kind": "LinkedField",
                    "name": "ticketTimeRegistrations",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "minutesRegistered",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "billableMinutesRegistered",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "notes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "date",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "day",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "month",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "year",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Task",
                        "kind": "LinkedField",
                        "name": "task",
                        "plural": false,
                        "selections": (v34/*: any*/),
                        "storageKey": null
                      },
                      (v38/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "role",
                        "plural": false,
                        "selections": (v34/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TicketWatcher",
                    "kind": "LinkedField",
                    "name": "watchers",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v38/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aiSummaryState",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TicketAiSummary",
                    "kind": "LinkedField",
                    "name": "aiSummary",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "summary",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusSignal",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sentiment",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commentCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emailCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "generatedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "modelVersion",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "feedbackScore",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "feedbackText",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isFinal",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TicketAiSummaryStaleness",
                        "kind": "LinkedField",
                        "name": "staleness",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isStale",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "newComments",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "newEmails",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "newStatusEvents",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "total",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TicketAiSuggestedAction",
                    "kind": "LinkedField",
                    "name": "aiSuggestedActions",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "suggestedDueDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rationale",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "confidence",
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "assignee",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v11/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "timeline",
                "plural": true,
                "selections": [
                  (v18/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isActivityEvent"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v15/*: any*/),
                      (v39/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bodyHtml",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "direction",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "authorType",
                        "storageKey": null
                      },
                      (v40/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deliveryStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "retryCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "toEmails",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ccEmails",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MessageAttachment",
                        "kind": "LinkedField",
                        "name": "attachments",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "inlineContentId",
                            "storageKey": null
                          },
                          (v25/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MessageActivity",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v15/*: any*/),
                      (v39/*: any*/),
                      (v40/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "mentionedUsers",
                        "plural": true,
                        "selections": (v37/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "InternalCommentActivity",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "eventType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "actor",
                        "plural": false,
                        "selections": (v37/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "oldValue",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "newValue",
                        "storageKey": null
                      }
                    ],
                    "type": "EventActivity",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v15/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/)
                    ],
                    "type": "AttachmentActivity",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TicketAttachment",
                "kind": "LinkedField",
                "name": "attachments",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "uploadedBy",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v11/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "10fbce67f63ae93b0135d00e7e8857be",
    "id": null,
    "metadata": {},
    "name": "useTicketDetailBySlugQuery",
    "operationKind": "query",
    "text": "query useTicketDetailBySlugQuery(\n  $slug: String!\n) {\n  viewer {\n    actualPersonId\n    ticketDetailBySlug(slug: $slug) {\n      ticket {\n        id\n        slug\n        subject\n        description\n        status\n        priority\n        channel\n        assigneeId\n        assignee {\n          fullName\n          ...ticketingPerson_person\n          id\n        }\n        requester {\n          id\n          name\n          email\n        }\n        createdAt\n        updatedAt\n        closedAt\n        links {\n          __typename\n          linkType\n          targetTicket {\n            id\n          }\n          targetProject {\n            id\n          }\n          id\n        }\n        timeEntries {\n          id\n        }\n        ...TicketDetailHeader_ticket\n        ...TicketMetaPanel_ticket\n        ...RelatedTab_ticket\n        ...LinkedTasksTab_ticket\n        ...TimeTab_ticket\n        ...WatchersList_ticket\n        ...AiSummaryBlock_ticket\n        ...AiSuggestedActionsList_ticket\n        linkedTasks {\n          id\n        }\n        ticketTimeRegistrations {\n          id\n        }\n      }\n      timeline {\n        __typename\n        ...ActivityTimelineItem_activity\n        ...ActivityTab_activity\n        ...StreamTab_activity\n        ... on AttachmentActivity {\n          id\n        }\n        ... on EventActivity {\n          id\n        }\n        ... on InternalCommentActivity {\n          id\n        }\n        ... on MessageActivity {\n          id\n        }\n      }\n      attachments {\n        id\n        filename\n        contentType\n        sizeBytes\n        downloadUrl\n        uploadedBy {\n          id\n          fullName\n          ...ticketingPerson_person\n        }\n        uploadedByName\n        createdAt\n      }\n    }\n    id\n  }\n}\n\nfragment ActivityTab_activity on ActivityEvent {\n  __isActivityEvent: __typename\n  __typename\n  ... on MessageActivity {\n    createdAt\n  }\n  ... on InternalCommentActivity {\n    createdAt\n  }\n  ... on EventActivity {\n    createdAt\n  }\n  ... on AttachmentActivity {\n    createdAt\n  }\n  ...ActivityTimelineItem_activity\n}\n\nfragment ActivityTimelineItem_activity on ActivityEvent {\n  __isActivityEvent: __typename\n  __typename\n  ... on MessageActivity {\n    id\n    createdAt\n    body\n    bodyHtml\n    direction\n    authorType\n    author {\n      id\n      fullName\n    }\n    deliveryStatus\n    retryCount\n    toEmails\n    ccEmails\n    attachments {\n      id\n      filename\n      contentType\n      sizeBytes\n      inlineContentId\n      downloadUrl\n    }\n  }\n  ... on InternalCommentActivity {\n    id\n    createdAt\n    body\n    author {\n      id\n      fullName\n    }\n    mentionedUsers {\n      id\n      fullName\n    }\n  }\n  ... on EventActivity {\n    id\n    createdAt\n    eventType\n    actor {\n      id\n      fullName\n    }\n    oldValue\n    newValue\n  }\n  ... on AttachmentActivity {\n    id\n    createdAt\n    filename\n    contentType\n    sizeBytes\n    downloadUrl\n  }\n}\n\nfragment AiSuggestedActionsList_ticket on Ticket {\n  id\n  status\n  aiSummary {\n    generatedAt\n    isFinal\n  }\n  aiSuggestedActions {\n    id\n    title\n    suggestedDueDate\n    rationale\n    confidence\n    status\n    assignee {\n      id\n      fullName\n      initials\n      profilePictureId\n      active\n      ...ticketingPerson_person\n    }\n  }\n}\n\nfragment AiSummaryBlock_ticket on Ticket {\n  id\n  status\n  aiSummaryState\n  aiSummary {\n    summary\n    statusSignal\n    sentiment\n    commentCount\n    emailCount\n    generatedAt\n    modelVersion\n    feedbackScore\n    feedbackText\n    isFinal\n    staleness {\n      isStale\n      newComments\n      newEmails\n      newStatusEvents\n      total\n    }\n  }\n  aiSuggestedActions {\n    id\n    title\n    suggestedDueDate\n    rationale\n    confidence\n    status\n    assignee {\n      id\n      fullName\n      initials\n      profilePictureId\n      active\n      ...ticketingPerson_person\n    }\n  }\n}\n\nfragment LinkedTasksTab_ticket on Ticket {\n  id\n  aiSuggestedLinkedTaskIds\n  totalLinkedTaskMinutes\n  linkedTasks {\n    id\n    companyTaskId\n    name\n    totalMinutesRegistered\n    estimateForecastMinutes\n    deadlineYear\n    deadlineMonth\n    deadlineDay\n    statusColumnV2 {\n      name\n      id\n    }\n    project {\n      id\n      name\n    }\n    assignedPersons {\n      id\n      fullName\n    }\n  }\n}\n\nfragment RelatedTab_ticket on Ticket {\n  id\n  links {\n    id\n    linkType\n    createdAt\n    targetTicket {\n      id\n      number\n      subject\n      status\n      assignee {\n        fullName\n        active\n        ...ticketingPerson_person\n        id\n      }\n    }\n    targetProject {\n      id\n      name\n      color\n    }\n  }\n}\n\nfragment StreamTab_activity on ActivityEvent {\n  __isActivityEvent: __typename\n  __typename\n  ... on MessageActivity {\n    id\n    createdAt\n    body\n    bodyHtml\n    authorType\n    author {\n      fullName\n      id\n    }\n    direction\n  }\n  ... on InternalCommentActivity {\n    id\n    createdAt\n    body\n    author {\n      fullName\n      id\n    }\n    mentionedUsers {\n      id\n      fullName\n    }\n  }\n  ... on EventActivity {\n    id\n    createdAt\n  }\n  ... on AttachmentActivity {\n    id\n    createdAt\n  }\n}\n\nfragment TicketDetailHeader_ticket on Ticket {\n  id\n  subject\n  description\n  status\n  priority\n  channel\n  slug\n  number\n  createdAt\n  assigneeId\n  isWatching\n  watcherCount\n  totalLoggedHours\n  totalBillableHours\n  sla {\n    breached\n    elapsedSeconds\n    thresholdSeconds\n    paused\n  }\n  requester {\n    name\n    id\n  }\n}\n\nfragment TicketMetaPanel_ticket on Ticket {\n  id\n  status\n  priority\n  channel\n  assigneeId\n  assignee {\n    ...ticketingPerson_person\n    id\n  }\n  requester {\n    id\n    name\n    email\n  }\n  createdAt\n  updatedAt\n  closedAt\n  labels {\n    id\n    name\n    color\n    category {\n      name\n      id\n    }\n  }\n  parentTicket {\n    id\n    number\n    subject\n    status\n  }\n  links {\n    id\n    linkType\n    targetProject {\n      id\n      name\n    }\n  }\n  customFields {\n    edges {\n      node {\n        __typename\n        id\n        key\n        type\n        displayName\n        value\n        displayValue\n        ... on TextCustomFieldValue {\n          readOnly\n        }\n        ... on IntegerCustomFieldValue {\n          readOnly\n        }\n        ... on DecimalCustomFieldValue {\n          readOnly\n        }\n        ... on DateCustomFieldValue {\n          readOnly\n        }\n        ... on DropdownCustomFieldValue {\n          options {\n            id\n            displayName\n          }\n        }\n      }\n    }\n  }\n  sla {\n    breached\n    elapsedSeconds\n    thresholdSeconds\n    paused\n  }\n}\n\nfragment TimeTab_ticket on Ticket {\n  id\n  linkedTasks {\n    id\n    name\n    project {\n      id\n    }\n  }\n  ticketTimeRegistrations {\n    id\n    minutesRegistered\n    billableMinutesRegistered\n    notes\n    date\n    day\n    month\n    year\n    task {\n      name\n      id\n    }\n    person {\n      ...ticketingPerson_person\n      id\n    }\n    role {\n      name\n      id\n    }\n  }\n}\n\nfragment WatchersList_ticket on Ticket {\n  id\n  isWatching\n  watcherCount\n  assigneeId\n  watchers {\n    id\n    person {\n      id\n      ...ticketingPerson_person\n    }\n  }\n}\n\nfragment ticketingPerson_person on Person {\n  id\n  firstName\n  lastName\n  fullName\n  initials\n  profilePictureId\n  active\n}\n"
  }
};
})();

(node as any).hash = "4e56418d1d77b0728f77ed3d4bd508c6";

export default node;
